import Carousel, { consts } from "react-elastic-carousel";
import "./styles.css";

import book from "../../Assets/images/book.png";
import sweat from "../../Assets/images/sweat.png";
import shirt from "../../Assets/images/shirt.png";
import sticker from "../../Assets/images/sticker.png";
import sweat2 from "../../Assets/images/sweat2.png";
import Bottle from "../../Assets/images/bottle.png";
import arrow1 from "../../Assets/images/arrow-left.svg";
import arrow2 from "../../Assets/images/arrow-right.svg";

const breakPoints = [
  { width: 1, divsToShow: 1 },
  { width: 550, itemsToShow: 2, itemsToScroll: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 4 },
];

const shopItems = [
  {
    img: book,
    title: "Green Book of Life",
    amount: "1,200",
  },
  {
    img: sweat,
    title: "Green Sweatshirt",
    amount: "6,000",
  },
  {
    img: Bottle,
    title: "Green Bottle",
    amount: "7,000",
  },
  {
    img: book,
    title: "Green Book of Life",
    amount: "6,000",
  },
  {
    img: sweat2,
    title: "David Kope (Tribute)",
    amount: "1,200",
  },
  {
    img: shirt,
    title: "Hard Guy",
    amount: "1,200",
  },
  {
    img: sticker,
    title: "Aorthar Sticker",
    amount: "1,200",
  },
];

export default function Slider() {
  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? (!isEdge ? arrow1 : "") : arrow2;
    return (
      <span
        className="justify-content-center align-items-center d-flex "
        onClick={onClick}
        disabled={isEdge}
      >
        {pointer ? (
          <img
            className="mb-3 slider-arrow"
            alt="aorthar arrow"
            src={pointer}
          />
        ) : (
          <span style={{ width: 64 }} className="slider-arrow" />
        )}
      </span>
    );
  };
  return (
    <div className="container mt-2">
      <Carousel
        renderPagination={() => <div />}
        renderArrow={myArrow}
        breakPoints={breakPoints}
      >
        {shopItems.map((item, i) => (
          <div key={i}>
            <img
              src={item.img}
              alt="Aorthar Merch Collection"
              className="a-shop-item"
              draggable="false"
              height="250px"
            />
            <div className="d-flex justify-content-between jus-slider-sub mt-3">
              <p className="a-slider-title">{item.title}</p>
              <p className="a-slider-amount bold">N{item.amount}</p>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
